import React from 'react';
import { FOOTER_ID } from 'globalConst/const';
import PropTypes from 'prop-types';
import styles from './Footer.styles';
import { withRouter } from 'react-router-dom';
import { createUseStyles } from 'react-jss';
import CONTENT_TYPES from 'globalConst/contentTypes-const';
import { FOOTER_NAVIGATION } from 'globalConst/const';
import ContentTypeComponent from 'components/ContentTypeComponent';

const useStyles = createUseStyles(styles, { name: 'Footer' });
const Footer = ({ location }) => {
  const classes = useStyles();
  const isOnHome = location.pathname === '/';

  return (
    <footer id={FOOTER_ID}>
      {isOnHome && (
        <h1 data-testid="proposition-text" className={classes.propositionText}>
          JUKE: Jouw gratis startpunt voor radio, podcasts en non-stop muziek
        </h1>
      )}
      <nav className={classes.footerContainer}>
        <ContentTypeComponent contentTypeId={CONTENT_TYPES.OVERVIEW_COLLECTION} slug={FOOTER_NAVIGATION} />
      </nav>
    </footer>
  );
};

Footer.propTypes = {
  location: PropTypes.object.isRequired,
};

export default withRouter(Footer);
